export interface ErrorInfo {
  errorCode: number;
  errorText: string;
  errorLinkText: string;
  errorLink: string;
}

export function isErrorInfo(object: any): object is ErrorInfo { // NOSONAR
  return (object as ErrorInfo).errorCode !== undefined &&
    (object as ErrorInfo).errorText !== undefined &&
    (object as ErrorInfo).errorLinkText !== undefined &&
    (object as ErrorInfo).errorLink !== undefined;
}
